/**
 * Friendly stand-in shown until an employee adds their own photo.
 *
 * Drawn as brand line art (PME blue outline on white, like the DAIVID
 * mascot) rather than a photo or a realistic face, so it reads as a
 * placeholder and does not stand for any one person.
 */
export default function PlaceholderPortrait({
  title,
  className,
}: {
  title: string;
  className?: string;
}) {
  return (
    <svg
      viewBox="0 0 400 400"
      role="img"
      aria-label={title}
      className={className}
      preserveAspectRatio="xMidYMid slice"
    >
      <title>{title}</title>
      <defs>
        <linearGradient id="pp-bg" x1="0" y1="0" x2="1" y2="1">
          <stop offset="0" stopColor="#dff3ff" />
          <stop offset="1" stopColor="#f8e9fc" />
        </linearGradient>
        <clipPath id="pp-clip">
          <rect width="400" height="400" />
        </clipPath>
      </defs>
      <rect width="400" height="400" fill="url(#pp-bg)" />

      {/* soft shapes behind the figure */}
      <circle cx="318" cy="92" r="64" fill="#ffffff" opacity="0.55" />
      <circle cx="70" cy="300" r="88" fill="#ffffff" opacity="0.4" />

      {/* sparkles */}
      <path
        fill="#df95ef"
        d="M72,62 Q74.6,81.4 96,84 Q74.6,86.6 72,106 Q69.4,86.6 48,84 Q69.4,81.4 72,62Z"
      />
      <path
        fill="#78d6ff"
        d="M112,40 Q113.4,50.6 124,52 Q113.4,53.4 112,64 Q110.6,53.4 100,52 Q110.6,50.6 112,40Z"
      />
      <path
        fill="#78d6ff"
        d="M330,214 Q332,229 348,232 Q332,235 330,250 Q328,235 312,232 Q328,229 330,214Z"
      />
      <path
        fill="#df95ef"
        d="M352,176 Q353.2,184.8 362,186 Q353.2,187.2 352,196 Q350.8,187.2 342,186 Q350.8,184.8 352,176Z"
      />

      <g clipPath="url(#pp-clip)">
        {/* shoulders and shirt */}
        <path
          d="M64,420 C64,340 118,300 200,300 C282,300 336,340 336,420 Z"
          fill="#ffffff"
          stroke="#0872c1"
          strokeWidth="9"
          strokeLinejoin="round"
        />
        {/* apron bib and neck strap */}
        <path
          d="M168,330 L180,296 M232,330 L220,296"
          stroke="#0872c1"
          strokeWidth="9"
          strokeLinecap="round"
          fill="none"
        />
        <path
          d="M146,420 L146,348 C146,334 156,326 170,326 L230,326 C244,326 254,334 254,348 L254,420 Z"
          fill="#0872c1"
        />
        <path
          d="M186,362 Q200,376 214,362"
          stroke="#78d6ff"
          strokeWidth="7"
          strokeLinecap="round"
          fill="none"
        />

        {/* neck */}
        <path
          d="M176,262 L176,300 Q200,318 224,300 L224,262 Z"
          fill="#ffffff"
          stroke="#0872c1"
          strokeWidth="9"
          strokeLinejoin="round"
        />

        {/* head */}
        <path
          d="M122,176 C122,128 156,104 200,104 C244,104 278,128 278,176 C278,232 244,272 200,272 C156,272 122,232 122,176 Z"
          fill="#ffffff"
          stroke="#0872c1"
          strokeWidth="9"
        />

        {/* hair, drawn over the top of the head */}
        <path
          d="M114,188 C100,102 148,56 204,56 C264,56 304,104 286,190 C283,164 270,144 250,134 C222,150 170,152 142,134 C126,148 118,166 114,188 Z"
          fill="#0c3c63"
        />

        {/* happy eyes */}
        <path
          d="M158,186 Q170,172 182,186 M218,186 Q230,172 242,186"
          stroke="#0c3c63"
          strokeWidth="9"
          strokeLinecap="round"
          fill="none"
        />
        {/* cheeks */}
        <circle cx="150" cy="212" r="12" fill="#df95ef" opacity="0.55" />
        <circle cx="250" cy="212" r="12" fill="#df95ef" opacity="0.55" />
        {/* smile */}
        <path
          d="M168,220 Q200,254 232,220"
          stroke="#0c3c63"
          strokeWidth="9"
          strokeLinecap="round"
          fill="none"
        />
      </g>
    </svg>
  );
}
